/** The session, through the one network gateway. Shapes come from the shared contract (P2). */
import type { SessionUserType } from '@thongketau/shared/contract/auth';

import { apiGet, apiPost } from './httpClient.js';

export type SessionUser = SessionUserType;

export const ME_QUERY_KEY = ['auth', 'me'] as const;

export const fetchMe = () => apiGet<SessionUser>('/api/auth/me');

export const signIn = (username: string, password: string) =>
  apiPost<SessionUser>('/api/auth/login', { body: { username, password } });

export const signOut = () => apiPost<void>('/api/auth/logout');
